import {WalletPlatform} from '@/enums/WalletPlatform'
import {TNetworksAvailable} from '@/model/wallets/types/WalletTypes'
import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'
import {WalletAdapter} from './WalletAdapter'
import {createWalletAdapter} from './WalletAdapterFactory'

const adapters = new Map<string, WalletAdapter>()

const key = (
  walletImplementation: TNetworksAvailable,
  network: TWalletNetwork,
  walletPlatform: WalletPlatform
) => `${walletImplementation}:${network}:${walletPlatform}`

export const getWalletAdapter = (
  walletImplementation: TNetworksAvailable,
  network: TWalletNetwork,
  walletPlatform: WalletPlatform
): WalletAdapter => {
  const id = key(walletImplementation, network, walletPlatform)
  const existing = adapters.get(id)

  if (existing) {
    return existing
  }

  const adapter = createWalletAdapter(
    walletPlatform,
    walletImplementation,
    network
  )
  adapters.set(id, adapter)

  return adapter
}

export const getBuiltWalletAdapters = (
  walletImplementation: TNetworksAvailable,
  network: TWalletNetwork
): WalletAdapter[] =>
  Object.values(WalletPlatform)
    .map(platform => adapters.get(key(walletImplementation, network, platform)))
    .filter((adapter): adapter is WalletAdapter => !!adapter)
